import {
  action, observable, flow, makeObservable,
} from 'mobx';
import UserAPI from '../api/user';
import BaseStore from './BaseStore';

class UserStore extends BaseStore {
  isUserBusy = false;
  isUserSending = false;
  userInfo = {};
  userProInfo = {};

  constructor() {
    super();

    makeObservable(this, {
      isUserBusy: observable,
      isUserSending: observable,
      userInfo: observable,
      userProInfo: observable,
      signIn: action,
      signUp: action,
    });
  }

  signIn = async (data, formikBag) => {
    const { setErrors } = formikBag;

    try {
      const response = await UserAPI.signIn(data);
      this.userInfo = response.data;
      return response.data;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      return Promise.reject();
    }
  };

  signUp = async (data, formikBag) => {
    const { setErrors } = formikBag;

    try {
      const response = await UserAPI.signUp(data);
      this.userInfo = response.data;
      return response.data;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      return Promise.reject();
    }
  };

  getUser = flow(function* () {
    this.isUserBusy = true;

    try {
      const { data } = yield UserAPI.getUser();
      this.userInfo = data;
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.log(errors.response.data.errorMessages);
    } finally {
      this.isUserBusy = false;
    }
  });

  setUser = flow(function* (payload, formikBag) {
    const { setErrors } = formikBag;

    this.isUserSending = true;
    try {
      const { data } = yield UserAPI.setUser(payload);
      this.userInfo = data;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      throw errors;
    } finally {
      this.isUserSending = false;
    }
  });

  signUpTheoryAccessStudent = flow(function* (schoolId, payload, formikBag) {
    const { setErrors } = formikBag;

    try {
      const { data } = yield UserAPI.signUpTheoryAccessStudent(schoolId, { student: payload });
      this.userInfo = data;
      return data;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      throw errors;
    }
  });

  signUpTheoryAccessStudentWithFb = flow(function* (schoolId, payload, formikBag) {
    const { setErrors } = formikBag;

    try {
      const { data } = yield UserAPI.signUpTheoryAccessStudentWithFb(schoolId, payload);
      this.userInfo = data;
      return data;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      throw errors;
    }
  });

  getProUser = flow(function* () {
    this.isUserBusy = true;

    try {
      const { data } = yield UserAPI.getProUser();
      this.userProInfo = data;
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.log(errors.response.data.errorMessages);
    } finally {
      this.isUserBusy = false;
    }
  });

  createCandidateLibre = flow(function* (payload, formikBag) {
    const { setErrors } = formikBag;

    try {
      yield UserAPI.createCandidateLibre({ candidat: payload });
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      throw errors;
    }
  });
}

export default new UserStore();
